// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  encounterId: __t.u64().name("encounter_id"),
  index: __t.u32(),
  gold: __t.u32(),
  value: __t.u32(),
  heroId: __t.option(__t.u64()).name("hero_id"),
  soldGold: __t.u32().name("sold_gold"),
});
